import { Outlet } from "react-router-dom"

const ResetPasswordLayout = () => {

    return (
        <Outlet />
    )
}

export default ResetPasswordLayout;